module.exports = __webpack_public_path__ + "static/university_of_west_alabama-1ccacce9b844ea64de654386860591fb.jpg";